import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowUpRight, Briefcase, Users, Globe, Award, Building2, TrendingUp, Cpu, Plane, HeartPulse, DollarSign, Factory, Sparkles, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HomePage() {
  return <div className="bg-white" data-id="element-505" data-mp="3ko0flhm8kfm7">
      {/* ─── HERO — Editorial Split Masthead ─────────────────── */}
      <section className="relative min-h-screen bg-navy-950 text-white overflow-hidden flex items-center" data-id="element-506" data-mp="2wyekb58zikjh">
        {/* Background — subtle */}
        <div className="absolute inset-0 z-0" data-id="element-507" data-mp="36qk8s5012jtx">
          <img src="https://images.unsplash.com/photo-1486325212027-8081e485255e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80" alt="" className="w-full h-full object-cover opacity-[0.08]" data-id="element-508" data-mp="36seuvmn1chzl" />
          <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/95 to-navy-950" data-id="element-509" data-mp="29bg4m9sovgmm" />
        </div>

        {/* Decorative gold orbs */}
        <div className="absolute top-0 left-0 w-[700px] h-[700px] bg-gold-500/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-510" data-mp="2aomszab2ccn6" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gold-500/[0.03] rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-511" data-mp="2jhgngez2zilm" />

        <div className="relative z-10 w-full pt-40 pb-28 md:pt-44 md:pb-32" data-id="element-512" data-mp="2ofrwinhjxp2s">
          <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-513" data-mp="1rr2bwpejiid4">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-514" data-mp="1vrmc61ueu23h">
              {/* LEFT — Headline + CTAs */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1]
            }} className="lg:col-span-7" data-id="element-515" data-mp="20pnps792h97k">
                {/* Eyebrow with animated underline */}
                <motion.div initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 0.2,
                duration: 0.6
              }} className="flex items-center gap-4 mb-10" data-id="element-516" data-mp="2mhyvjjp5z3ok">
                  <motion.div initial={{
                  width: 0
                }} animate={{
                  width: 48
                }} transition={{
                  delay: 0.4,
                  duration: 0.8
                }} className="h-px bg-gold-500" data-id="element-517" data-mp="23r8v01n2fsyv" />
                  <span className="text-gold-500 font-semibold tracking-[0.35em] uppercase text-[11px]" data-id="element-518" data-mp="1l0r29x28gxdi">
                    Global Executive Search & Talent Advisory
                  </span>
                </motion.div>

                {/* Headline */}
                <h1 className="font-serif font-bold leading-[0.98] tracking-tight mb-10 text-[44px] sm:text-6xl lg:text-[76px] xl:text-[86px]" data-id="element-519" data-mp="5azxh3n926ho">
                  Connecting{' '}
                  <span className="italic text-gold-500 inline-block" data-id="element-520" data-mp="3rq1golcyd87o">
                    exceptional
                  </span>
                  <br className="hidden sm:block" data-id="element-521" data-mp="j9zmiceocned" />
                  <span className="block sm:inline" data-id="element-522" data-mp="o8t1yadiuoh6">
                    {' '}
                    leadership talent with{' '}
                  </span>
                  <span className="text-white" data-id="element-523" data-mp="a88kbhjceyp9">high-growth</span>
                  <br className="hidden sm:block" data-id="element-524" data-mp="e926o6h505g1" />
                  organizations worldwide.
                </h1>

                {/* Subheadline */}
                <motion.p initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.5,
                duration: 0.8
              }} className="text-lg md:text-xl text-gray-300 leading-relaxed mb-12 max-w-2xl font-light" data-id="element-525" data-mp="2v13jkwhqcy7c">
                  We help organizations secure transformative executive, board,
                  and strategic leadership talent globally — with the
                  discretion, precision, and judgment the most demanding
                  searches require.
                </motion.p>

                {/* CTAs */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.7,
                duration: 0.6
              }} className="flex flex-col sm:flex-row gap-4 mb-14" data-id="element-526" data-mp="3o9zv9go546w9">
                  <Button variant="gold" size="lg" href="mailto:contact@talentbridge.blog" data-id="element-527" data-mp="sbqzxbc67ep4">
                    Book a Consultation
                    <ArrowRight className="ml-2 h-4 w-4" data-id="element-528" data-mp="122bu8mkt9x28" />
                  </Button>
                  <Button variant="outline" size="lg" href="/contact" className="text-white border-white/40 hover:bg-white hover:text-navy-900" data-id="element-529" data-mp="16z2apb0j2uo6">
                    Submit Resume
                  </Button>
                </motion.div>

                {/* Inline trust strip */}
                <motion.div initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 1,
                duration: 0.8
              }} className="flex flex-wrap items-center gap-6 md:gap-10 pt-8 border-t border-white/10" data-id="element-530" data-mp="3hsf052cpyorx">
                  <div className="flex items-center gap-2 text-xs text-gray-400" data-id="element-531" data-mp="12yr5omaiz8ze">
                    <div className="w-2 h-2 rounded-full bg-gold-500 animate-pulse" data-id="element-532" data-mp="xx1pytccy74z" />
                    <span className="tracking-wider uppercase" data-id="element-533" data-mp="1cukcrq5h6a9s">
                      Available for new mandates
                    </span>
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-534" data-mp="17ug58pmjopvp">
                    <span className="text-gold-500 font-semibold" data-id="element-535" data-mp="1lme1hzv5qrag">AESC</span>{' '}
                    Member Firm
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-536" data-mp="1hogb4tpnhz5h">
                    <span className="text-white" data-id="element-537" data-mp="1vmn01kcmgot0">ISO 27001</span> Certified
                  </div>
                </motion.div>
              </motion.div>

              {/* RIGHT — Premium executive imagery + floating credentials */}
              <motion.div initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 1,
              delay: 0.4,
              ease: [0.22, 1, 0.36, 1]
            }} className="lg:col-span-5 hidden lg:block relative" data-id="element-538" data-mp="2a6hfvwvopl71">
                <div className="relative" data-id="element-539" data-mp="1w9kmpos3frmz">
                  {/* Decorative offset frame */}
                  <div className="absolute -top-6 -left-6 w-full h-full border border-gold-500/40" data-id="element-540" data-mp="1hl7p6ndcy0qd" />
                  <div className="absolute -bottom-6 -right-6 w-full h-full border border-white/10" data-id="element-541" data-mp="1mjrbwpzrzgjs" />

                  {/* Main image */}
                  <div className="relative aspect-[4/5] overflow-hidden" data-id="element-542" data-mp="18lkmly8w6ovq">
                    <img src="https://images.unsplash.com/photo-1664575602276-acd073f104c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=85" alt="Executive leadership" className="w-full h-full object-cover" data-id="element-543" data-mp="1cka5258sewm8" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/20 to-transparent" data-id="element-544" data-mp="1j0k2k9e2lje8" />

                    {/* Floating stat — top */}
                    <motion.div initial={{
                    opacity: 0,
                    y: -20
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    delay: 1.2,
                    duration: 0.6
                  }} className="absolute top-6 left-6 right-6 bg-navy-900/80 backdrop-blur-md border border-gold-500/30 p-5" data-id="element-545" data-mp="1a1oxx1qochd1">
                      <div className="text-[10px] uppercase tracking-[0.25em] text-gold-500 mb-1 font-semibold" data-id="element-546" data-mp="me8hoxgood2g">
                        Live Mandate
                      </div>
                      <div className="text-white text-sm font-serif" data-id="element-547" data-mp="31yzyrma1riqw">
                        CEO Search · Industrial Technology · Global
                      </div>
                    </motion.div>

                    {/* Floating stat — bottom */}
                    <motion.div initial={{
                    opacity: 0,
                    y: 20
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    delay: 1.4,
                    duration: 0.6
                  }} className="absolute bottom-6 left-6 right-6 bg-white text-navy-900 p-6" data-id="element-548" data-mp="2ebqmlqeai42t">
                      <div className="grid grid-cols-3 divide-x divide-gray-200" data-id="element-549" data-mp="20i97chsmzdil">
                        <div className="pr-3" data-id="element-550" data-mp="2bpmi02cm797s">
                          <div className="text-2xl font-serif font-bold" data-id="element-551" data-mp="2bt0foxac2u8w">
                            500+
                          </div>
                          <div className="text-[10px] uppercase tracking-widest text-gray-500 mt-1 leading-tight" data-id="element-552" data-mp="2lokcrn0mvyz8">
                            Placements
                          </div>
                        </div>
                        <div className="px-3" data-id="element-553" data-mp="1t1hfey7p1uak">
                          <div className="text-2xl font-serif font-bold" data-id="element-554" data-mp="1xz983ug5xkft">
                            42
                          </div>
                          <div className="text-[10px] uppercase tracking-widest text-gray-500 mt-1 leading-tight" data-id="element-555" data-mp="22xb23af4n462">
                            Countries
                          </div>
                        </div>
                        <div className="pl-3" data-id="element-556" data-mp="1a8vq6wral1yy">
                          <div className="text-2xl font-serif font-bold" data-id="element-557" data-mp="1f8rs8qgfijbv">
                            94%
                          </div>
                          <div className="text-[10px] uppercase tracking-widest text-gray-500 mt-1 leading-tight" data-id="element-558" data-mp="3shzzbqz1u9t4">
                            Retention
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Scroll indicator */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.6,
          duration: 1
        }} className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-3 text-white/40 text-[10px] tracking-[0.3em] uppercase" data-id="element-559" data-mp="39kyse0lxpzmj">
            <span data-id="element-560" data-mp="2qsw6oaufrt5f">Explore</span>
            <motion.div animate={{
            scaleY: [0.3, 1, 0.3]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-px h-12 bg-gradient-to-b from-gold-500 via-white/40 to-transparent origin-top" data-id="element-561" data-mp="2luuqbxoea7xn" />
          </motion.div>
        </div>
      </section>

      {/* ─── CREDIBILITY STRIP — "Trusted by" ─────────────────── */}
      <section className="bg-white border-b border-gray-100 py-12" data-id="element-562" data-mp="2uxglqwotauxh">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-563" data-mp="2uy8hq8mbmuoa">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16" data-id="element-564" data-mp="2zwt7fe3y5vyh">
            <div className="flex items-center gap-3 flex-shrink-0" data-id="element-565" data-mp="2m5y6cnzowj5g">
              <div className="w-10 h-px bg-gold-500" data-id="element-566" data-mp="2q6qgdjgdys2s" />
              <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-[11px] whitespace-nowrap" data-id="element-567" data-mp="2q5fbfgb7fea3">
                Trusted by leadership teams at
              </span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-8 gap-y-4 flex-1" data-id="element-568" data-mp="3iom17aqubl79">
              {['Fortune 500 Industrials', 'Global Healthcare Systems', 'PE Portfolio Companies', 'Sovereign Wealth Funds', 'Tech Unicorns', 'Family Offices'].map((client, i) => <div key={i} className="text-sm font-serif text-navy-900/70 hover:text-navy-900 transition-colors tracking-tight" data-id="element-569" data-mp="1c03lw78xfq84" data-mpi={i}>
                  {client}
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* ─── TRUST METRICS ─────────────────────────────────────── */}
      <section className="py-20 bg-white border-b border-gray-100" data-id="element-570" data-mp="t79d5v1wcucc">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-571" data-mp="29mam74y76weo">
          <div className="text-center mb-16" data-id="element-572" data-mp="29kpstinmdjie">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-573" data-mp="24nzd4wfq8pxi">
              <div className="w-8 h-px bg-gold-500" data-id="element-574" data-mp="24psjeamfh84z" />
              <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-575" data-mp="e7nokcgqpb8q">
                Our Capability
              </span>
              <div className="w-8 h-px bg-gold-500" data-id="element-576" data-mp="n70oadf2alg9" />
            </div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900" data-id="element-577" data-mp="n5pjca9vr7nk">
              A trusted partner to global leadership teams
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-200" data-id="element-578" data-mp="x4f3yat5v67i">
            {[{
            icon: Globe,
            label: 'Global Talent Network',
            detail: '42 countries · 6 regional offices'
          }, {
            icon: Users,
            label: 'Executive Search Specialists',
            detail: 'Senior consultants with industry depth'
          }, {
            icon: Briefcase,
            label: 'C-Suite & Board Recruitment',
            detail: 'CEO, CFO, CHRO, CTO, and board mandates'
          }, {
            icon: TrendingUp,
            label: 'International Hiring Support',
            detail: 'Cross-border placements & advisory'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="px-6 py-8 md:py-4 text-center md:text-left" data-id="element-579" data-mp="1h09m1jpz8185" data-mpi={index}>
                <item.icon className="h-7 w-7 text-gold-500 mx-auto md:mx-0 mb-4" data-id="element-580" data-mp="2wh01m92n6e1y" />
                <h3 className="text-lg font-serif font-bold text-navy-900 mb-2 leading-snug" data-id="element-581" data-mp="2ro6y1oiwtbrg">
                  {item.label}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-582" data-mp="uqjecg04tsqf">
                  {item.detail}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── SERVICES ──────────────────────────────────────────── */}
      <section className="py-28 bg-gray-50" data-id="element-583" data-mp="kyn3e4cy684s">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-584" data-mp="70f8s33dviws">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-585" data-mp="731fk0ig9udy">
            <div className="lg:col-span-5" data-id="element-586" data-mp="c1mii7p36s63">
              <div className="flex items-center gap-3 mb-6" data-id="element-587" data-mp="3t8ewheiw3r15">
                <div className="w-12 h-px bg-gold-500" data-id="element-588" data-mp="3t9zrt6d13e02" />
                <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-589" data-mp="212e4w69t7jn">
                  Practice Areas
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight" data-id="element-590" data-mp="1wfwjqi0s4k1v">
                Advisory built around the most consequential hires.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end" data-id="element-591" data-mp="3bz49jnfnpsbf">
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-592" data-mp="3bwrlqtn7wnqg">
                From CEO succession to board composition to strategic capability
                builds, our consultants work as long-term partners to leadership
                teams — not transactional recruiters.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200" data-id="element-593" data-mp="3vnd2w0sxs4ci">
            {[{
            num: '01',
            title: 'Executive Search',
            desc: 'Confidential CEO, C-suite, and senior leadership mandates for public, private, and PE-backed organizations.'
          }, {
            num: '02',
            title: 'Board Recruitment',
            desc: 'Independent director searches, board composition advisory, and governance consulting.'
          }, {
            num: '03',
            title: 'Leadership Advisory',
            desc: 'Succession planning, executive assessment, and onboarding for new leaders.'
          }, {
            num: '04',
            title: 'Resume & Career Positioning',
            desc: 'Executive-level personal branding, resume strategy, and LinkedIn positioning for senior professionals.'
          }, {
            num: '05',
            title: 'Talent Acquisition Consulting',
            desc: 'In-house TA function design, employer branding, and high-volume hiring strategy.'
          }, {
            num: '06',
            title: 'Global Mobility',
            desc: 'Cross-border placement, work authorization advisory, and international relocation support.'
          }].map((service, index) => <motion.div key={index} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white p-10 group hover:bg-navy-900 transition-colors duration-500 cursor-pointer" data-id="element-594" data-mp="k69vq81wu2se" data-mpi={index}>
                <div className="flex items-center justify-between mb-8" data-id="element-595" data-mp="3sltm8zb7573r">
                  <span className="text-3xl font-serif text-gold-500 group-hover:text-gold-500 transition-colors" data-id="element-596" data-mp="3sopjelf7zrr5">
                    {service.num}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-gray-300 group-hover:text-gold-500 transition-colors" data-id="element-597" data-mp="3ipzzyo7odz8s" />
                </div>
                <h3 className="text-xl font-serif font-bold text-navy-900 group-hover:text-white mb-4 transition-colors leading-tight" data-id="element-598" data-mp="1gwslti3stnoh">
                  {service.title}
                </h3>
                <p className="text-gray-600 group-hover:text-gray-300 transition-colors leading-relaxed text-sm" data-id="element-599" data-mp="28spof66du4tl">
                  {service.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── INDUSTRIES ────────────────────────────────────────── */}
      <section className="py-28 bg-white" data-id="element-600" data-mp="1q0wv1aneihlc">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-601" data-mp="1q1yiyfpimykh">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-602" data-mp="1l0rasfjgnxda">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-603" data-mp="1l3nao9evcw4d">
              <div className="w-12 h-px bg-gold-500" data-id="element-604" data-mp="1g2pq5q6dzpzp" />
              <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-605" data-mp="1b3ml45qepjrq">
                Sector Expertise
              </span>
              <div className="w-12 h-px bg-gold-500" data-id="element-606" data-mp="3affl8b8hr58o" />
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight mb-6" data-id="element-607" data-mp="35i70q3zvep49">
              Deep specialization across the industries shaping tomorrow.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-608" data-mp="3hyom1g2xlvm4">
              Each practice is led by consultants with operating experience in
              the sectors they serve.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-gray-200" data-id="element-609" data-mp="3rp1ervkwgv3c">
            {[{
            icon: Cpu,
            name: 'Technology',
            desc: 'Software, SaaS, cybersecurity, cloud infrastructure'
          }, {
            icon: Plane,
            name: 'Aerospace',
            desc: 'Defense, commercial aviation, space technology'
          }, {
            icon: HeartPulse,
            name: 'Healthcare',
            desc: 'Biotech, medical devices, health systems'
          }, {
            icon: DollarSign,
            name: 'Finance',
            desc: 'Banking, asset management, fintech, insurance'
          }, {
            icon: Factory,
            name: 'Manufacturing',
            desc: 'Industrial, automotive, supply chain'
          }, {
            icon: Sparkles,
            name: 'AI & Emerging Technology',
            desc: 'Machine learning, robotics, quantum computing'
          }].map((ind, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white p-10 group hover:bg-gray-50 transition-colors duration-300 relative overflow-hidden cursor-pointer" data-id="element-610" data-mp="3710eylvui5eq" data-mpi={index}>
                <div className="absolute top-0 left-0 h-1 w-0 group-hover:w-full bg-gold-500 transition-all duration-500" data-id="element-611" data-mp="18ionisrra5nj" />
                <ind.icon className="h-8 w-8 text-navy-900 mb-6 group-hover:text-gold-500 transition-colors" data-id="element-612" data-mp="tuk1bethvc00" />
                <h3 className="text-xl font-serif font-bold text-navy-900 mb-3" data-id="element-613" data-mp="ytx08xxn49iy">
                  {ind.name}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-614" data-mp="1mj94dje41ree">
                  {ind.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── TESTIMONIALS ──────────────────────────────────────── */}
      <section className="py-28 bg-navy-900 text-white relative overflow-hidden" data-id="element-615" data-mp="1hi1yjpvj32ad">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-616" data-mp="22cvl9fj1k0e" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-617" data-mp="65rce2bai4ew" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-618" data-mp="md5kyv34nrwg">
          <div className="flex items-center gap-3 mb-12 justify-center" data-id="element-619" data-mp="hj1iop4t481p">
            <div className="w-12 h-px bg-gold-500" data-id="element-620" data-mp="cmktdrlvfnn1" />
            <span className="text-gold-500 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-621" data-mp="cj6mq766cs9s">
              Client Voices
            </span>
            <div className="w-12 h-px bg-gold-500" data-id="element-622" data-mp="15agjuekukjbd" />
          </div>

          {/* Large featured quote */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-4xl mx-auto text-center mb-20" data-id="element-623" data-mp="10c59m2qn46sm">
            <div className="text-gold-500 font-serif text-7xl leading-none mb-6" data-id="element-624" data-mp="3g05c8wsdx8vn">
              "
            </div>
            <p className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-10 text-white" data-id="element-625" data-mp="3c30ukx5edgbg">
              TalentBridge delivered a CEO candidate who reshaped our
              trajectory. The quality of judgment they brought to the search was
              unlike any firm we'd worked with before.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-626" data-mp="25ak4y06cqypt">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gold-500 to-gold-600 flex items-center justify-center text-navy-900 font-serif text-lg font-bold" data-id="element-627" data-mp="25bv8pzzss6gx">
                MR
              </div>
              <div className="text-left" data-id="element-628" data-mp="2j9s3cquoy2sy">
                <div className="font-bold text-white" data-id="element-629" data-mp="2jb3an0nchsot">Margaret Rosenthal</div>
                <div className="text-sm text-gray-400" data-id="element-630" data-mp="2o94sji91blyp">
                  Board Chair · Fortune 500 Industrial
                </div>
              </div>
            </div>
          </motion.div>

          {/* Supporting quotes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-631" data-mp="tvdm0rm05i7h">
            {[{
            quote: 'Their global reach and discretion were essential for a sensitive cross-border CFO search. Flawless execution.',
            author: 'Henrik Voss',
            role: 'Managing Partner',
            company: 'European PE Firm',
            initials: 'HV'
          }, {
            quote: 'The board composition advisory transformed how we think about governance. Strategic, thoughtful, and rigorous.',
            author: 'Aisha Bashir',
            role: 'Independent Director',
            company: 'Global Healthcare',
            initials: 'AB'
          }, {
            quote: 'A genuine partnership — not transactional. They understand our culture and only present candidates who fit.',
            author: 'Daniel Kovacs',
            role: 'CHRO',
            company: 'Tech Unicorn',
            initials: 'DK'
          }].map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="border-l-2 border-gold-500/40 pl-6" data-id="element-632" data-mp="3igwq30kvcag2" data-mpi={i}>
                <p className="text-gray-300 leading-relaxed mb-6 italic" data-id="element-633" data-mp="2zjvm9j31wgdp">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-634" data-mp="2prpsc3t8novv">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-gold-500 font-bold text-sm" data-id="element-635" data-mp="2pq4yyhinubzl">
                    {t.initials}
                  </div>
                  <div data-id="element-636" data-mp="2ft9yht2tu1io">
                    <div className="font-semibold text-white text-sm" data-id="element-637" data-mp="2w9kifs19zkj3">
                      {t.author}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-638" data-mp="2ra7wd9i8ahhk">
                      {t.role} · {t.company}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* ─── FINAL CTA — Partner With TalentBridge ─────────────── */}
      <section className="py-28 bg-white" data-id="element-639" data-mp="2dc9is6bqep34">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-640" data-mp="28k9qn01wl0h3">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-641" data-mp="28iovp9boffip">
            {/* Left: Pitch */}
            <div data-id="element-642" data-mp="23isshcaszs47">
              <div className="flex items-center gap-3 mb-6" data-id="element-643" data-mp="1yltzwy6sft84">
                <div className="w-12 h-px bg-gold-500" data-id="element-644" data-mp="1yndgkpwcw6af" />
                <span className="text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-645" data-mp="1tn8v0lglcldc">
                  Begin a Conversation
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900 leading-tight mb-8" data-id="element-646" data-mp="533e1ycdj02m">
                Partner With <span className="italic" data-id="element-647" data-mp="945doga7de54">TalentBridge</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-10" data-id="element-648" data-mp="e3rraqty0weg">
                Whether you are building a board, recruiting your next CEO, or
                considering your own next move — our consultants are available
                for a confidential, no-obligation conversation.
              </p>

              <ul className="space-y-4 mb-10" data-id="element-649" data-mp="3mj1qnr6g7nij">
                {['Confidential initial consultation', 'Senior consultant from your sector', 'No-commitment scoping conversation', 'Response within one business day'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-650" data-mp="2yt7frf5ow90x" data-mpi={i}>
                    <CheckCircle className="h-5 w-5 text-gold-500 mt-0.5 flex-shrink-0" data-id="element-651" data-mp="33stpvfq8195i" />
                    <span className="text-gray-700" data-id="element-652" data-mp="2dj6aciqu6mxh">{item}</span>
                  </li>)}
              </ul>

            </div>

            {/* Right: Consultation form */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-sm border border-gray-200 shadow-xl overflow-hidden" data-id="element-653" data-mp="2ifwrl9ednokh">
              <div className="bg-navy-900 text-white px-8 py-7" data-id="element-654" data-mp="1zl811rrdhgou">
                <h3 className="text-2xl font-serif font-bold mb-1" data-id="element-655" data-mp="1kvtsglvmf3ai">
                  Request a Consultation
                </h3>
                <p className="text-sm text-gray-400" data-id="element-656" data-mp="1pr918zeru902">
                  All inquiries are held in strict confidence.
                </p>
              </div>
              <iframe title="Request a consultation" src="https://form.jotform.com/261658116470559" className="w-full min-h-[620px] border-0 block" scrolling="no" data-id="element-657" data-mp="1grvq82b01cd8" />
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}